<script>
    import { onMount } from "svelte";
    import baseUrl from "../../config/config";
    import { MultiSelect } from "carbon-components-svelte";
    import Editor from "@tinymce/tinymce-svelte";
    import { v4 } from "uuid";
    import qs from "qs";

    let btnLoading = false;

    let productName;
    let sku;

    let regularPrice;

    let salePrice;

    let productCategories = [];

    let size;

    let stock;

    let description;

    let images;

    let percentage;

    let country;

    let tags;

    let packSize;

    let categories = [];

    onMount(() => {
        getCategories();
    });

    const getCategories = () => {
        // get the catgories
        fetch(baseUrl + "get-select-categories.php")
            .then((res) => res.json())
            .then((data) => {
                // console.log(data);
                categories = data;
            })
            .catch((e) => {
                console.log(e);
            });
    };

    const clearForm = () => {
        let form = document.getElementById("addProductForm");
        form.reset();
    };

    const addProduct = () => {
        let categoriesArray = [];

        for (let x = 0; x < productCategories.length; x++) {
            categoriesArray.push(productCategories[x].text);
        }

        if (salePrice > regularPrice) {
            toast.error("Sale Price Must Be Less Than Regular Price");
        } else {
            if (productCategories.length == 0) {
                toast.error("Product Categories Cannot Be Empty");
            } else {
                let productDetails = {
                    id: v4(),
                    slug: createSlug(productName),
                    name: productName,
                    categories: categoriesArray,
                    sku: sku,
                    size: size,
                    stock: stock,
                    tags: tags,
                    packSize: packSize,
                    country: country,
                    percentage: percentage,
                    description: description,
                    salePrice: salePrice,
                    reqularPrice: regularPrice,
                    visibility: "Public",
                    status: "active",
                };

                // start loading

                btnLoading = true;

                let fd = new FormData();

                // get the images
                var ins = document.getElementById("productImages").files.length;

                for (var x = 0; x < ins; x++) {
                    fd.append(
                        "files[]",
                        document.getElementById("productImages").files[x]
                    );
                }

                let pd = qs.stringify(productDetails);

                // append
                fd.append("productData", pd);

                // post the data
                jQuery.ajax({
                    url: baseUrl + "add-product.php", // point to server-side PHP script
                    dataType: "text", // what to expect back from the PHP script
                    cache: false,
                    contentType: false,
                    processData: false,
                    data: fd,
                    type: "post",
                    success: function (response) {
                        console.log(response);

                        let res = JSON.parse(response);

                        if (res.success) {
                            toast.success(res.message);
                        } else {
                            toast.error(res.message);
                        }

                        clearForm();

                        btnLoading = false;
                    },
                    error: function (response) {
                        console.log(response);
                        alert(res.message);

                        btnLoading = false;
                    },
                });
            }
        }
    };

    function createSlug(str) {
        str = str.replace(/^\s+|\s+$/g, ""); // trim
        str = str.toLowerCase();

        // remove accents, swap ñ for n, etc
        var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
        var to = "aaaaeeeeiiiioooouuuunc------";
        for (var i = 0, l = from.length; i < l; i++) {
            str = str.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
        }

        str = str
            .replace(/[^a-z0-9 -]/g, "") // remove invalid chars
            .replace(/\s+/g, "-") // collapse whitespace and replace by -
            .replace(/-+/g, "-"); // collapse dashes

        return str;
    }
</script>

<main>
    <div class="mainContainer">
        <form class="ui form" id="addProductForm" on:submit|preventDefault={addProduct}>
            <div class="two fields">
                <div class="field">
                    <label for="name"> Product Name </label>
                    <input
                        type="text"
                        name="name"
                        id="name"
                        placeholder="Product Name"
                        required
                        bind:value={productName}
                    />
                </div>

                <div class="field">
                    <label for="name"> SKU/Code </label>
                    <input
                        type="text"
                        name="sku"
                        id="sku"
                        placeholder="SKU"
                        required
                        bind:value={sku}
                    />
                </div>
            </div>

            <div class="two fields">
                <div class="field">
                    <label for="regularPrice">Regular Price</label>
                    <input
                        type="number"
                        name="reqularPrice"
                        id="reqularPrice"
                        placeholder="0.00"
                        bind:value={regularPrice}
                    />
                </div>

                <div class="field">
                    <label for="slaePrice">Sale Price</label>
                    <input
                        type="number"
                        name="salePrice"
                        id="salePrice"
                        placeholder="0.00"
                        bind:value={salePrice}
                        
                    />
                </div>
            </div>

            <div class="two fields">
                <div class="field">
                    <MultiSelect
                        titleText="Categories"
                        label="Select Categories"
                        items={categories}
                        on:select={(val) => {
                            productCategories = val.detail.selected;
                        }}
                    />
                </div>

                <div class="field">
                    <label for="size">Size</label>
                    <input
                        type="text"
                        name="size"
                        id="size"
                        placeholder="750ml 1l 3l"
                        required
                        bind:value={size}
                    />
                </div>
            </div>

            <div class="two fields">
                <div class="field">
                    <label for="tags">Tags</label>
                    <input
                        type="text"
                        name="tags"
                        id="tag"
                        bind:value={tags}
                        required
                        placeholder="tags comma separated"
                    />
                </div>

                <div class="field">
                    <label for="stock">Stock</label>
                    <input
                        type="number"
                        name="stock"
                        id="stock"
                        placeholder="00"
                        required
                        bind:value={stock}
                    />
                </div>
            </div>
            <br /> <br />
            <div class="two fields">
                <div class="field">
                    <label for="images">Product Images</label>
                    <input
                        type="file"
                        name="images"
                        id="productImages"
                        multiple
                        required
                        bind:value={images}
                    />
                </div>

                <div class="field">
                    <label for="percentage"> Alcohol % </label>
                    <input
                        type="number"
                        name="percentage"
                        id="percentage"
                        placeholder="40"
                        required
                        bind:value={percentage}
                    />
                </div>
            </div>

            <div class="two fields">
                <div class="field">
                    <label for="country">Country</label>
                    <select id="country" name="country" bind:value={country}>
                        <option value="">Country Of Origin</option>
                        <option value="Afganistan">Afghanistan</option>
                        <option value="Albania">Albania</option>
                        <option value="Algeria">Algeria</option>
                        <option value="American Samoa">American Samoa</option>
                        <option value="Andorra">Andorra</option>
                        <option value="Angola">Angola</option>
                        <option value="Anguilla">Anguilla</option>
                        <option value="Antigua & Barbuda"
                            >Antigua & Barbuda</option
                        >
                        <option value="Argentina">Argentina</option>
                        <option value="Armenia">Armenia</option>
                        <option value="Aruba">Aruba</option>
                        <option value="Australia">Australia</option>
                        <option value="Austria">Austria</option>
                        <option value="Azerbaijan">Azerbaijan</option>
                        <option value="Bahamas">Bahamas</option>
                        <option value="Bahrain">Bahrain</option>
                        <option value="Bangladesh">Bangladesh</option>
                        <option value="Barbados">Barbados</option>
                        <option value="Belarus">Belarus</option>
                        <option value="Belgium">Belgium</option>
                        <option value="Belize">Belize</option>
                        <option value="Benin">Benin</option>
                        <option value="Bermuda">Bermuda</option>
                        <option value="Bhutan">Bhutan</option>
                        <option value="Bolivia">Bolivia</option>
                        <option value="Bonaire">Bonaire</option>
                        <option value="Bosnia & Herzegovina"
                            >Bosnia & Herzegovina</option
                        >
                        <option value="Botswana">Botswana</option>
                        <option value="Brazil">Brazil</option>
                        <option value="British Indian Ocean Ter"
                            >British Indian Ocean Ter</option
                        >
                        <option value="Brunei">Brunei</option>
                        <option value="Bulgaria">Bulgaria</option>
                        <option value="Burkina Faso">Burkina Faso</option>
                        <option value="Burundi">Burundi</option>
                        <option value="Cambodia">Cambodia</option>
                        <option value="Cameroon">Cameroon</option>
                        <option value="Canada">Canada</option>
                        <option value="Canary Islands">Canary Islands</option>
                        <option value="Cape Verde">Cape Verde</option>
                        <option value="Cayman Islands">Cayman Islands</option>
                        <option value="Central African Republic"
                            >Central African Republic</option
                        >
                        <option value="Chad">Chad</option>
                        <option value="Channel Islands">Channel Islands</option>
                        <option value="Chile">Chile</option>
                        <option value="China">China</option>
                        <option value="Christmas Island"
                            >Christmas Island</option
                        >
                        <option value="Cocos Island">Cocos Island</option>
                        <option value="Colombia">Colombia</option>
                        <option value="Comoros">Comoros</option>
                        <option value="Congo">Congo</option>
                        <option value="Cook Islands">Cook Islands</option>
                        <option value="Costa Rica">Costa Rica</option>
                        <option value="Cote DIvoire">Cote DIvoire</option>
                        <option value="Croatia">Croatia</option>
                        <option value="Cuba">Cuba</option>
                        <option value="Curaco">Curacao</option>
                        <option value="Cyprus">Cyprus</option>
                        <option value="Czech Republic">Czech Republic</option>
                        <option value="Denmark">Denmark</option>
                        <option value="Djibouti">Djibouti</option>
                        <option value="Dominica">Dominica</option>
                        <option value="Dominican Republic"
                            >Dominican Republic</option
                        >
                        <option value="East Timor">East Timor</option>
                        <option value="Ecuador">Ecuador</option>
                        <option value="Egypt">Egypt</option>
                        <option value="El Salvador">El Salvador</option>
                        <option value="Equatorial Guinea"
                            >Equatorial Guinea</option
                        >
                        <option value="Eritrea">Eritrea</option>
                        <option value="Estonia">Estonia</option>
                        <option value="Ethiopia">Ethiopia</option>
                        <option value="Falkland Islands"
                            >Falkland Islands</option
                        >
                        <option value="Faroe Islands">Faroe Islands</option>
                        <option value="Fiji">Fiji</option>
                        <option value="Finland">Finland</option>
                        <option value="France">France</option>
                        <option value="French Guiana">French Guiana</option>
                        <option value="French Polynesia"
                            >French Polynesia</option
                        >
                        <option value="French Southern Ter"
                            >French Southern Ter</option
                        >
                        <option value="Gabon">Gabon</option>
                        <option value="Gambia">Gambia</option>
                        <option value="Georgia">Georgia</option>
                        <option value="Germany">Germany</option>
                        <option value="Ghana">Ghana</option>
                        <option value="Gibraltar">Gibraltar</option>
                        <option value="Great Britain">Great Britain</option>
                        <option value="Greece">Greece</option>
                        <option value="Greenland">Greenland</option>
                        <option value="Grenada">Grenada</option>
                        <option value="Guadeloupe">Guadeloupe</option>
                        <option value="Guam">Guam</option>
                        <option value="Guatemala">Guatemala</option>
                        <option value="Guinea">Guinea</option>
                        <option value="Guyana">Guyana</option>
                        <option value="Haiti">Haiti</option>
                        <option value="Hawaii">Hawaii</option>
                        <option value="Honduras">Honduras</option>
                        <option value="Hong Kong">Hong Kong</option>
                        <option value="Hungary">Hungary</option>
                        <option value="Iceland">Iceland</option>
                        <option value="Indonesia">Indonesia</option>
                        <option value="India">India</option>
                        <option value="Iran">Iran</option>
                        <option value="Iraq">Iraq</option>
                        <option value="Ireland">Ireland</option>
                        <option value="Isle of Man">Isle of Man</option>
                        <option value="Israel">Israel</option>
                        <option value="Italy">Italy</option>
                        <option value="Jamaica">Jamaica</option>
                        <option value="Japan">Japan</option>
                        <option value="Jordan">Jordan</option>
                        <option value="Kazakhstan">Kazakhstan</option>
                        <option value="Kenya">Kenya</option>
                        <option value="Kiribati">Kiribati</option>
                        <option value="Korea North">Korea North</option>
                        <option value="Korea Sout">Korea South</option>
                        <option value="Kuwait">Kuwait</option>
                        <option value="Kyrgyzstan">Kyrgyzstan</option>
                        <option value="Laos">Laos</option>
                        <option value="Latvia">Latvia</option>
                        <option value="Lebanon">Lebanon</option>
                        <option value="Lesotho">Lesotho</option>
                        <option value="Liberia">Liberia</option>
                        <option value="Libya">Libya</option>
                        <option value="Liechtenstein">Liechtenstein</option>
                        <option value="Lithuania">Lithuania</option>
                        <option value="Luxembourg">Luxembourg</option>
                        <option value="Macau">Macau</option>
                        <option value="Macedonia">Macedonia</option>
                        <option value="Madagascar">Madagascar</option>
                        <option value="Malaysia">Malaysia</option>
                        <option value="Malawi">Malawi</option>
                        <option value="Maldives">Maldives</option>
                        <option value="Mali">Mali</option>
                        <option value="Malta">Malta</option>
                        <option value="Marshall Islands"
                            >Marshall Islands</option
                        >
                        <option value="Martinique">Martinique</option>
                        <option value="Mauritania">Mauritania</option>
                        <option value="Mauritius">Mauritius</option>
                        <option value="Mayotte">Mayotte</option>
                        <option value="Mexico">Mexico</option>
                        <option value="Midway Islands">Midway Islands</option>
                        <option value="Moldova">Moldova</option>
                        <option value="Monaco">Monaco</option>
                        <option value="Mongolia">Mongolia</option>
                        <option value="Montserrat">Montserrat</option>
                        <option value="Morocco">Morocco</option>
                        <option value="Mozambique">Mozambique</option>
                        <option value="Myanmar">Myanmar</option>
                        <option value="Nambia">Nambia</option>
                        <option value="Nauru">Nauru</option>
                        <option value="Nepal">Nepal</option>
                        <option value="Netherland Antilles"
                            >Netherland Antilles</option
                        >
                        <option value="Netherlands"
                            >Netherlands (Holland, Europe)</option
                        >
                        <option value="Nevis">Nevis</option>
                        <option value="New Caledonia">New Caledonia</option>
                        <option value="New Zealand">New Zealand</option>
                        <option value="Nicaragua">Nicaragua</option>
                        <option value="Niger">Niger</option>
                        <option value="Nigeria">Nigeria</option>
                        <option value="Niue">Niue</option>
                        <option value="Norfolk Island">Norfolk Island</option>
                        <option value="Norway">Norway</option>
                        <option value="Oman">Oman</option>
                        <option value="Pakistan">Pakistan</option>
                        <option value="Palau Island">Palau Island</option>
                        <option value="Palestine">Palestine</option>
                        <option value="Panama">Panama</option>
                        <option value="Papua New Guinea"
                            >Papua New Guinea</option
                        >
                        <option value="Paraguay">Paraguay</option>
                        <option value="Peru">Peru</option>
                        <option value="Phillipines">Philippines</option>
                        <option value="Pitcairn Island">Pitcairn Island</option>
                        <option value="Poland">Poland</option>
                        <option value="Portugal">Portugal</option>
                        <option value="Puerto Rico">Puerto Rico</option>
                        <option value="Qatar">Qatar</option>
                        <option value="Republic of Montenegro"
                            >Republic of Montenegro</option
                        >
                        <option value="Republic of Serbia"
                            >Republic of Serbia</option
                        >
                        <option value="Reunion">Reunion</option>
                        <option value="Romania">Romania</option>
                        <option value="Russia">Russia</option>
                        <option value="Rwanda">Rwanda</option>
                        <option value="St Barthelemy">St Barthelemy</option>
                        <option value="St Eustatius">St Eustatius</option>
                        <option value="St Helena">St Helena</option>
                        <option value="St Kitts-Nevis">St Kitts-Nevis</option>
                        <option value="St Lucia">St Lucia</option>
                        <option value="St Maarten">St Maarten</option>
                        <option value="St Pierre & Miquelon"
                            >St Pierre & Miquelon</option
                        >
                        <option value="St Vincent & Grenadines"
                            >St Vincent & Grenadines</option
                        >
                        <option value="Saipan">Saipan</option>
                        <option value="Samoa">Samoa</option>
                        <option value="Samoa American">Samoa American</option>
                        <option value="San Marino">San Marino</option>
                        <option value="Sao Tome & Principe"
                            >Sao Tome & Principe</option
                        >
                        <option value="Saudi Arabia">Saudi Arabia</option>
                        <option value="Scotland">Scotland</option>
                        <option value="Senegal">Senegal</option>
                        <option value="Seychelles">Seychelles</option>
                        <option value="Sierra Leone">Sierra Leone</option>
                        <option value="Singapore">Singapore</option>
                        <option value="Slovakia">Slovakia</option>
                        <option value="Slovenia">Slovenia</option>
                        <option value="Solomon Islands">Solomon Islands</option>
                        <option value="Somalia">Somalia</option>
                        <option value="South Africa">South Africa</option>
                        <option value="Spain">Spain</option>
                        <option value="Sri Lanka">Sri Lanka</option>
                        <option value="Sudan">Sudan</option>
                        <option value="Suriname">Suriname</option>
                        <option value="Swaziland">Swaziland</option>
                        <option value="Sweden">Sweden</option>
                        <option value="Switzerland">Switzerland</option>
                        <option value="Syria">Syria</option>
                        <option value="Tahiti">Tahiti</option>
                        <option value="Taiwan">Taiwan</option>
                        <option value="Tajikistan">Tajikistan</option>
                        <option value="Tanzania">Tanzania</option>
                        <option value="Thailand">Thailand</option>
                        <option value="Togo">Togo</option>
                        <option value="Tokelau">Tokelau</option>
                        <option value="Tonga">Tonga</option>
                        <option value="Trinidad & Tobago"
                            >Trinidad & Tobago</option
                        >
                        <option value="Tunisia">Tunisia</option>
                        <option value="Turkey">Turkey</option>
                        <option value="Turkmenistan">Turkmenistan</option>
                        <option value="Turks & Caicos Is"
                            >Turks & Caicos Is</option
                        >
                        <option value="Tuvalu">Tuvalu</option>
                        <option value="Uganda">Uganda</option>
                        <option value="United Kingdom">United Kingdom</option>
                        <option value="Ukraine">Ukraine</option>
                        <option value="United Arab Erimates"
                            >United Arab Emirates</option
                        >
                        <option value="United States of America"
                            >United States of America</option
                        >
                        <option value="Uraguay">Uruguay</option>
                        <option value="Uzbekistan">Uzbekistan</option>
                        <option value="Vanuatu">Vanuatu</option>
                        <option value="Vatican City State"
                            >Vatican City State</option
                        >
                        <option value="Venezuela">Venezuela</option>
                        <option value="Vietnam">Vietnam</option>
                        <option value="Virgin Islands (Brit)"
                            >Virgin Islands (Brit)</option
                        >
                        <option value="Virgin Islands (USA)"
                            >Virgin Islands (USA)</option
                        >
                        <option value="Wake Island">Wake Island</option>
                        <option value="Wallis & Futana Is"
                            >Wallis & Futana Is</option
                        >
                        <option value="Yemen">Yemen</option>
                        <option value="Zaire">Zaire</option>
                        <option value="Zambia">Zambia</option>
                        <option value="Zimbabwe">Zimbabwe</option>
                    </select>
                </div>

                <div class="field">
                    <div class="field">
                        <label for="packSize">Pack Size</label>
                        <input
                            type="number"
                            name="packSize"
                            id="packSize"
                            placeholder="1"
                            required
                            bind:value={packSize}
                        />
                    </div>
                </div>
            </div>
            <div class="field">
                <label for="description">Description</label>
                <Editor
                    apiKey="54qs6f65thgm1sr5p5vl9nk0dx7ljadxg51ixnwj18j6y66a"
                    conf={{
                        skin: "oxide-dark",
                        content_css: "dark",
                        plugins: "print image table emoticons",
                        height: 400,
                    }}
                    bind:value={description}
                />
            </div>
            <div class="two fields" />

            <div class="field" style="text-align:center;padding-top:1em;">
                {#if btnLoading}
                    <button class="ui green basic loading button">
                        <i class="ui plus icon" /> Add Product
                    </button>
                {:else}
                    <button class="ui  green basic button">
                        <i class="ui plus icon" /> Add Product
                    </button>
                {/if}
            </div>
        </form>
    </div>
</main>

<style>
    .mainContainer {
        padding: 1em;
    }

    label {
        color: aliceblue !important;
        font-weight: 100 !important;
    }

    input {
        background: #272727 !important;
        color: aliceblue !important;
    }

    select {
        background: #272727 !important;
        color: aliceblue !important;
    }
</style>
